import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

export const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  display: flex;
  gap: 2rem;

  @media (max-width: 968px) {
    flex-direction: column;
  }
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const PageHeader = styled.div`
  margin-bottom: 2rem;
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const PageSubtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
`;

export const FilterBar = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
`;

export const FilterTab = styled.button<{ $active: boolean }>`
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: 2px solid ${(props) => (props.$active ? "#C8553D" : "#e0e0e0")};
  background: ${(props) => (props.$active ? "#C8553D" : "white")};
  color: ${(props) => (props.$active ? "white" : "#666")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #c8553d;
    color: ${(props) => (props.$active ? "white" : "#C8553D")};
  }
`;

export const OrdersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const OrderCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

export const OrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const OrderInfo = styled.div`
  flex: 1;
`;

export const OrderId = styled.div`
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.25rem;
`;

export const OrderDate = styled.div`
  font-size: 0.875rem;
  color: #999;
`;

export const StatusBadge = styled.div<{ $status: string }>`
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 700;
  font-size: 0.875rem;
  text-transform: capitalize;
  display: inline-block;
  animation: ${(props) =>
    props.$status === "pending" ? "pulse 2s infinite" : "none"};

  ${(props) => {
    switch (props.$status) {
      case "pending":
        return "background: #FFE9D5; color: #7A3E1F;";
      case "confirmed":
        return "background: #E0F2F3; color: #558B8D;";
      case "preparing":
        return "background: #e0e7ff; color: #4338ca;";
      case "delivering":
        return "background: #fce7f3; color: #9f1239;";
      case "delivered":
        return "background: #E0F2F3; color: #3A5F60;";
      case "cancelled":
        return "background: #FFE5DD; color: #8B3828;";
      default:
        return "background: #f3f4f6; color: #374151;";
    }
  }}

  @keyframes pulse {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }
`;

export const UpdatedBadge = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  font-size: 0.625rem;
  font-weight: 700;
  background: #c8553d;
  color: white;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const OrderItems = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

export const OrderItemPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 0.875rem;
`;

export const ItemCount = styled.span`
  font-weight: 700;
  color: #c8553d;
`;

export const OrderFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 2px solid #f0f0f0;
`;

export const OrderTotal = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
`;

export const ViewButton = styled.button`
  padding: 0.5rem 1.5rem;
  background: transparent;
  color: #c8553d;
  border: 2px solid #c8553d;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: #c8553d;
    color: white;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem;
`;

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #e0e0e0;
  border-top-color: #c8553d;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 4rem 2rem;
  background: white;
  border-radius: 12px;
`;

export const EmptyIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

export const EmptyTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 0.5rem;
`;

export const EmptyText = styled.p`
  color: #666;
  font-size: 1rem;
  margin-bottom: 2rem;
`;

export const BrowseButton = styled.button`
  padding: 1rem 2rem;
  background: #c8553d;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: #b04731;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
`;

export const PaginationInfo = styled.div`
  color: #666;
  font-size: 0.95rem;
`;

export const PaginationButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const PaginationButton = styled.button<{ $disabled?: boolean }>`
  padding: 0.5rem 1rem;
  background: ${(props) => (props.$disabled ? "#f5f5f5" : "white")};
  color: ${(props) => (props.$disabled ? "#ccc" : "#C8553D")};
  border: 2px solid ${(props) => (props.$disabled ? "#e0e0e0" : "#C8553D")};
  border-radius: 8px;
  font-weight: 600;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s;

  &:hover {
    background: ${(props) => (props.$disabled ? "#f5f5f5" : "#C8553D")};
    color: ${(props) => (props.$disabled ? "#ccc" : "white")};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
